module.exports = __webpack_public_path__ + "media/images/athletes/1701-35c0c1a0abf9420e07c38c4feb37f7aa.png";